export enum EServiceCategory {
    Product = 1,
    Service = 2
}